export * from "@catchy/region-config";
